import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import combineClassName from "./utils/combineClassName";

export interface SectionHeaderProps {
  icon: ReactNode;
  title: string;
  action?: string;
  actionTo?: string;
}

export function SectionHeader({
  icon,
  title,
  action,
  actionTo,
}: SectionHeaderProps) {
  return (
    <div className="flex items-center justify-between gap-3 mb-3">
      <div className="flex items-center gap-3 min-w-0">
        {icon}
        <h3 className="text-base font-bold text-gray-800 truncate">{title}</h3>
      </div>
      {action && actionTo && (
        <Link
          to={actionTo}
          className="text-sm font-medium text-electrum-300 hover:text-electrum shrink-0"
        >
          {action}
        </Link>
      )}
    </div>
  );
}

export interface SectionPanelProps {
  children: ReactNode;
  className?: string;
}

/**
 * Rounded outline card used for toolbox sections and similar panels.
 */
export function SectionPanel({ children, className }: SectionPanelProps) {
  return (
    <div
      className={combineClassName([
        "rounded-xl border border-gray-200 bg-white p-4",
        className ?? "",
      ])}
    >
      {children}
    </div>
  );
}

export interface SectionEmptyStateProps {
  children: ReactNode;
  className?: string;
}

/**
 * Centered body for empty section content (typically copy with optional links).
 */
export function SectionEmptyState({
  children,
  className,
}: SectionEmptyStateProps) {
  return (
    <div className={combineClassName(["py-4 text-center", className ?? ""])}>
      {children}
    </div>
  );
}
